import axios from 'axios';

export default class QueuingTime {
    private tableElement: HTMLElement;

    constructor(uniqueID: string, private updateUrl: string, private refreshInterval: number, private properties: any) {
        this.tableElement = document.getElementById(uniqueID);

        if (this.tableElement) {
            this.updateTable();
            this.scheduleUpdates();
        }
    }

    private scheduleUpdates() {
        setInterval(() => this.updateTable(), this.refreshInterval);
    }

    private async updateTable() {
        try {
            const response = await axios.post(this.updateUrl, this.properties, {
                headers: { 'Content-Type': 'application/json' }
            });

            const data = response.data;
            this.renderTable(data);
        } catch (error) {
            console.error('Error updating table:', error);
        }
    }

    private renderTable(data: any) {
        const tbody = this.tableElement?.querySelector('tbody');
        if (!tbody) return;

        tbody.innerHTML = '';

        if (!data || data.length === 0) {
            tbody.innerHTML = `<tr><td colspan="3">No DVS centres available.</td></tr>`;
            return;
        }

        tbody.innerHTML = data;

    }
}
